import _ from 'lodash';
import langs from 'utils/plural/langs';

export const isPlural = (str) => /^{\w+,\s?plural,\s?.+}$/.test(str);
export const parsePlural = (lang, str, params) => {
  const pluralFunction = langs[lang];
  if (!pluralFunction) {
    return str;
  }
/*
  const plurals = _(str).split(/^{(\w+),\s?plural,(.+)}$/);
  const name = plurals.nth(1);
  const words = _(plurals.nth(2)).split('}').compact().map(v => v.split('{#').map(_.trim)).fromPairs().value();
*/

  const plurals = _.split(str, /^{(\w+),\s?plural,(.+)}$/);
  const name = _.nth(plurals, 1);
  const _words = _.nth(plurals,2);
  const words = _.fromPairs(_.compact(_.split(_words, '}')).map(v => v.split('{#').map(_.trim)));


  if (_.has(params, name)) {
    return _.get(words, pluralFunction(params[name]), `{${name}}`);
  } else {
    return `{${name}}`;
  }
};
